import React, { useState, useEffect } from "react";
import { makeStyles, Grid, Button } from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";
import RotateLeftIcon from "@material-ui/icons/RotateLeft";
import TextField from "../../../../../../Component/Forms/TextField";
import DateField from "../../../../../../Component/Forms/DateField";
import MultiSelect from "../../../../../../Component/Forms/MultiSelect";

import { recordTypes as rts } from "../../../../../../API/config";
import { useTranslation } from "react-i18next";

const styles = (theme) => ({
  pageHeaderContainer: {
    padding: 15,
    borderBottom: "1px solid #cac5c5d9",
  },
});

const useStyles = makeStyles(styles);

const Search = ({ handleSearch }) => {
  const classes = useStyles();
  const [rtActions, setRtActions] = useState([]);
  const [actionList, setActionList] = useState([]);
  const [recordTypeList, setRecordTypeList] = useState([]);
  const [user, setUser] = useState();
  const [recordName, setRecordName] = useState();
  const [actions, setActions] = useState([]);
  const [recordTypes, setRecordTypes] = useState([]);
  const [fromDateTime, setFromDateTime] = useState();
  const [toDateTime, setToDateTime] = useState();
  const { t } = useTranslation();

  useEffect(() => {
    const rtActions = [];
    const actionNames = [];
    for (let rt in rts) {
      for (let a in rts[rt].actions) {
        if (rts[rt].actions[a].auditable) {
          if (actionNames.indexOf(rts[rt].actions[a].label) < 0) {
            rtActions.push(rts[rt].actions[a]);
            actionNames.push(rts[rt].actions[a].label);
          }
        }
      }
    }
    setActionList(actionNames.sort());
    setRtActions(rtActions);
    setRecordTypeList(
      Object.keys(rts)
        .filter((rt) => rts[rt].auditable)
        .map((r) => {
          return rts[r].label;
        })
    );
  }, []);

  const search = () => {
    const actionValues = rtActions
      .filter((a) => actions.indexOf(a.label) > -1)
      .map((a) => a.name);
    const recordTypeValues = Object.keys(rts).filter(
      (r) => recordTypes.indexOf(rts[r].label) > -1
    );

    handleSearch({
      user,
      recordName: recordName,
      actions: actionValues,
      recordTypes: recordTypeValues,
      fromDateTime,
      toDateTime,
    });
  };

  const reset = () => {
    setUser(null);
    setActions([]);
    setRecordTypes([]);
    setFromDateTime(null);
    setToDateTime(null);
  };

  const onActionChange = (values) => {
    setActions(values || []);
  };

  const onRecordTypeChange = (values) => {
    setRecordTypes(values || []);
  };

  return (
    <div className={classes.pageHeaderContainer}>
      <Grid container spacing={2}>
        <Grid item xs={3}>
          <TextField
            label={t("labels.audit.searchForm.user")}
            initialValue={user}
            type="text"
            onChange={setUser}
          />
        </Grid>
        <Grid item xs={3}>
          <TextField
            label={t("labels.audit.searchForm.recordName")}
            initialValue={recordName}
            type="text"
            onChange={setRecordName}
          />
        </Grid>
        <Grid item xs={3}>
          <MultiSelect
            label={t("labels.audit.searchForm.actions")}
            options={actionList}
            initialValues={actions || []}
            changeHandler={onActionChange}
          />
        </Grid>
        <Grid item xs={3}>
          <MultiSelect
            label={t("labels.audit.searchForm.recordTypes")}
            options={recordTypeList}
            initialValues={recordTypes || []}
            changeHandler={onRecordTypeChange}
          />
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <Grid item xs={3}>
          <DateField
            label={t("labels.audit.searchForm.dateRangeFrom")}
            isRequired={true}
            labelErrorText={""}
            initialValue={fromDateTime}
            onChange={(d) => setFromDateTime(d)}
          />
        </Grid>
        <Grid item xs={3}>
          <DateField
            label={t("labels.audit.searchForm.dateRangeTo")}
            isRequired={true}
            labelErrorText={""}
            initialValue={toDateTime}
            onChange={(d) => setToDateTime(d)}
          />
        </Grid>

        <Grid item xs={4}></Grid>
        <Grid item xs={2}>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
              height: "100%",
              width: "100%",
            }}
          >
            <Button
              color="primary"
              variant="contained"
              style={{ height: 35, marginRight: 5 }}
              onClick={reset}
            >
              <RotateLeftIcon />
            </Button>
            <Button
              color="primary"
              variant="contained"
              style={{ height: 35 }}
              onClick={search}
            >
              <SearchIcon />
            </Button>
          </div>
        </Grid>
      </Grid>
    </div>
  );
};

export default Search;
